export default {
    'applying-scq-process': {
        'course-title': 'Applying S C Q Process',
        'course-name': 'Section 4C - 1 <span class="unit-title">Applying S C Q Process<span>',
        'course-video': {
            'title': `
            Section 4 BUILDING A PYRAMID<br>
            1’37:17 – 1’38:06 4D APPLYING THE SCQ PROCESS (MASTER CLASS) :- <br>
            ex 4D master class in applying SCQ - 1’38:26 – 1’47:11 <br>
             Applying SCQ practice exercises
            `,
            'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1'
        },
        'unit-title': '4C-1 Lecture',
        'exercise-intro': `Before I turn you loose to apply the SCQ process to your own work, let me take you through a detailed example of the way I do the thinking when I am working out the structure of an introduction. You do not have to look at the video now, because it is very detailed, but if you find yourself later running into problems in applying SCQ, you may find it useful to watch it.`,
        'exercise-1': {
            'number': '4C-1 - Example',
            'title': 'Field Sales Force Meeting',
            'description': `
            This is an explanation of the background to the following memorandum, meant to go to the field sales force of a soft drinks company called Frosted Cola. Let us suppose that you work for the Vice President of Sales of Frosted Cola. You have been working on the new Space Management Program, designed to make optimum use of shelf space in supermarket chains. The Program is meant to help Frosted Cola gain more space in chains where its share of space is below its share of market - SO called problem chains.<br><br>
            You and the VP have designed a slide show explaining the new Space Management Program, which you have presented to the major chain headquarters groups. You now want to train the Field Sales Force District Managers to design and give the same kind of presentation to the problem chains in their 12 districts. You have announced that you will do this training at the August 25th Field Sales Meeting.<br><br>
            <ul class="exercise-list">
              <li>-	You will ask each of the 12 Field Sales people to select one problem chain in his district, and then send you market share and shelf space data on several of its stores</li>
              <li>-	You will use the data to prepare a tailored version of the presentation for each district</li>
              <li>-	At the Field Sales Meeting you will teach them to design and give similar presentations to other Chains in their areas</li>
              <li>-	They will go back and present the meeting version to their selected chain</li>
              <li>-	They will then work with the bottler body to select, research, and present their findings in similar presentations to other key local chains</li>
            </ul>
            <br>
            It is now June and you need the chains identified by July 11, and the data on each returned by August 15, if you are to be able to put together a presentation tailored for each district. The VP has asked you to draft a memo to go to the Field Sales Force explaining the kind of chain to pick, the data needed, and how it should be organized. You have prepared the attached draft, and have asked for his comments on it.<br><br>
            `,
            demo: `
            <p class="grey__paper-title--small">Subject: August Field Sales Meeting</p>


            <p>In preparation for the Field Sales Meeting during the week of August 25, we are requesting each region to profile a problem
              chain. The objective is to produce at the end of our meetings one presentation per region to seal the new Space Management
              Program. Our objective is also to familiarize the entire Field Sales staff in techniques to sell a proven presentation
              format utilizing the Shelf Space Study, Share of Market Study, and Nielsen data to local chain headquarters, with the consent
              and mutual working relationship of the bottler body.</p>

            <p class="grey__paper-title">DEFINING A PROBLEM CHAIN</p>

            <p>On the initial thrust, we do not want to go after the A&Ps, Safeways, Albertsons, etc. of the world, but the locally important
              chains. These are chains in a market where the headquarters are located and where they are important to the local bottlers
              - i.e., chains like White Stores in Knoxville, Tennessee, with a share of all commodity dollar volume of 16.6% with 39
              stores; Dahl’s Food Markets out of Des Moines, Iowa, with 9 stores and 29.1% of the food store volume; and Rousauers -
              Spokane, Washington, with 29 stores and 20.1% of the ACV.</p>

            <p>While these are not national chains, they are very important to the markets they are in. In fact, they are the leading chains
              in these markets. We do not know if there are problems in the above chains, but these have been used as an example of the
              type of chain stores we are looking for when you select your problem chain. In addition, the following criteria should
              also be followed in selecting a chain:</p>

            <ul class="grey-paper__list">
              <li>- A chain where our share of space is below our share of market</li>
              <li>- A chain where the stores are not completely vertically stacked</li>
              <li>- A chain where the bottler is aware of a problem and is willing to assist the field sales force in conducting the research required</li>
            </ul>
            <p>When you have selected your problem chain, please send me the name on the enclosed form no later than July 11.</p>

            <p class="grey__paper-title">RESEARCH - DETAIL AND INSTRUCTIONS ARE ENCLOSED</p>

            <ul class="grey-paper__list">
              <li>- Work with the key bottler to conduct a Shelf Space study in 9 to 10 stores. If the chain has only a few stores (4 to 8), do all the stores</li>
              <li>- Conduct a Share of Market study in 3 or 4 of these stores</li>
              <li>- Compile A. C. Nielsen data on the major market or franchise, if available, including share of market in detail, plus distribution and out-of-stock</li>
              <li>- Obtain the local bottler’s yearly sales to this chain</li>
            </ul>

            <p>We will need the above data by August 15, summarized as explained in the enclosed instructions. As a result of our August
              meeting, we will have assembled 12 presentations (one for each region) which will then be presented to the chain (with
              the bottler’s approval). In addition, the field sales force working with the bottler body can then start the process of
              selecting, researching, and presenting their findings to other key local chains.</p>
            `
        },
        'unit-section-title': '4C-1 Example',
        'patterns-1': {
            'title': 'Common Patterns Of Introduction In Business Documents',
            'thead-1': 'What should we do?',
            'thead-2': 'How should/do/will we do it?',
            'thead-3': 'Should we do it?',
            'thead-4': 'Why did it happen?',
            'tcell-1-1': `1. Resolve simple problem<br/>
S = Face X situation<br/>
C = Do not like what you have <br/>
Q = What should we do?<br/>`,
            'tcell-1-2': `2. Choose among alternative solutions<br/>
S = We want to do X<br/>
C = We have three choices of how <br/>
Q = Which is the best?<br/>
 `,
            'tcell-2-1': `3. Directive<br/>
S = We want to do X<br/>
C = Need your help to do it <br/>
Q = How do I help?<br/>
 `,
            'tcell-2-2': `4. Tell how to do something new<br/>
S = Must do X activity <br/>
C = Not set up to do it<br/>
Q = How do we get set up?<br/>
 `,
            'tcell-2-3': `5. Tell how to do something properly<br/>
S = We presently have system X <br/>
C = It does not work properly<br/>
Q = How make it work properly?<br/>
 `,
            'tcell-2-4': `6. Recommend strategy <br/>
S = Cannot do X as planned <br/>
C = Must take Y action<br/>
Q = How?<br/>`,
            'tcell-2-5': `7. Explain causes of an effect <br/>
S = Experiencing small change in X <br/>
C = Will cause big change in Y<br/>
Q = How specifically will Y change?<br/>`,
            'tcell-3-1': `8. Prove the need for action<br/>
S = Thinking about doing X<br/>
C = Don’t want to do unless Y is the case<br/>
Q = Is Y the case?<br/>`,
            'tcell-3-2': `9. Question the wisdom of an action <br/>
S = New proposal has been made C = Resembles the old proposal<br/>
Q = Does it make sense?<br/>`,
            'tcell-3-3': `10. Seek approval to spend money<br/>
S = We have a problem<br/>
C = We have a solution, but it needs $ to implement<br/>
Q = Should we approve the spending?<br/>`,
            'tcell-4-1': `11. Explain an occurrence (A)<br/>
S = For years there was only X C = Then suddenly everywhere<br/>
we got Y<br/>
Q = Why did that happen?<br/>`,
            'tcell-4-2': `12. Explain an occurrence (B)<br/>
S = X% did A<br/>
C = Y% did not do A <br/>
Q = Why not?<br/>`,
        },
        'patterns-2': {
            'title': 'Common Patterns Of Introduction In Consulting Documents',
            'thead-1': 'Should we do what is proposed?',
            'thead-2': 'What should we do?',
            'thead-3': 'How should/do we do something?',
            'tcell-1-1': `1. Is it the right action?<br/>
S = Have situation/problem<br/>
C = Plan action<br/>
Q = Is it the right action?<br/>
 `,
            'tcell-1-2': `2. Will there be a problem?<br/>
S = Had problem, have solution<br/>
C = Afraid there may be problem implementing it<br/>
Q = Will there be a problem?<br/>
 `,
            'tcell-1-3': `3. Does solution work?<br/>
S = Had problem, have solution<br/> C = Tested solution<br/>
Q = Is it OK?
 `,
            'tcell-1-4': `4. Will solution achieve objective?<br/>
S = Planning action<br/>
C = Don’t want to do unless achieve Y<br/> Q = Will it achieve Y?
 `,
            'tcell-1-5': `5. Letter of proposal (B)<br/>
S = You have a problem<br/>
C = You want consulting help to solve it<br/>
Q = Are we the consultant you should hire?
 `,
            'tcell-2-1': `1. How solve problem?<br/>
S = Did/want to do X/have situation<br/>
C = Didn’t work/can’t do/have problem<br/> Q = How proceed?
 `,
            'tcell-2-2': `2. How get desired action?<br/>S = Have problem<br/>
C = Want solution that does X<br/>
Q = What do to get that solution?
 `,
            'tcell-2-3': `3. Alternatives <br/>
S = Want to do X<br/>
C = Have alternative ways of doing it<br/> Q = Which is best?<br/>
 `,
            'tcell-2-4': `4. Audit <br/>
S = Now follow X process to achieve Y<br/>
C = Did audit to see if any changes needed<br/> Q = Any changes needed?<br/>
`,
            'tcell-2-5': `5. Progress Review No. 1<br/>
S = LOP said we would do X to solve problem<br/> C = Have now done it<br/>
Q = What did you find?
`,
            'tcell-3-1': `1. How do needed action?<br/>
S = Must do X to solve problem<br/> C = To do X must do Y<br/>
Q = How do I do Y?
`,
            'tcell-3-2': `2. How implement solution?<br/>
S = You have a problem & you have a solution<br/>
C = Not sure how to implement the solution<br/> Q = How implement the solution?
`,
            'tcell-3-3': `3. How did you do that?<br/>
S = We had a problem<br/>
C = We solved it by doing X<br/> Q = How did you do X?
`,
            'tcell-3-4': `4. How does it work?<br/>
S = Have/had objective<br/>
C = Installing system/process to accomplish<br/> Q = How does it work?
`,
            'tcell-3-5': `5. Letter of Proposal (A)<br/>
S = You have a problem<br/>
C = You want consulting help to solve it<br/>
Q = How will you help us solve our problem?
`,
        },
        'congratulation-message': 'GOOD GOING',
        'finish-section': 'You have completed Section 4C-1',
        'final-description': 'You know the basic patterns of most common introductions',
        'next-course-button': 'proceed to section 4C-2',
        'dashboard-button': 'Main menu',
    }
}




// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4c1/i18n/en.js